import { View, ActivityIndicator } from "react-native";
import StyledText from "./common/ui/styled-text";
import { LucideIcon } from "lucide-react-native";

const MetricCard = ({
  title,
  value,
  icon: Icon,
  iconColor = "#6b7280",
  loading = false,
}: {
  title: string;
  value: string;
  icon: LucideIcon;
  iconColor?: string;
  loading?: boolean;
}) => {
  return (
    <View
      className={`bg-card text-card-foreground flex flex-col rounded-lg border border-border py-6 relative`}
    >
      <View className="@container/card-header gap-1.5 px-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <StyledText className="leading-none text-sm font-semibold text-gray-600">
          {title}
        </StyledText>
        <Icon size={20} color={iconColor} />
      </View>
      <View className="px-6">
        {loading ? (
          <View className="flex flex-row items-center mb-1">
            <ActivityIndicator size="small" color="#111827" />
            <StyledText className="text-lg font-bold text-gray-900 ml-2">
              Loading...
            </StyledText>
          </View>
        ) : (
          <div className={`text-2xl font-bold mb-1 text-gray-900`}>{value}</div>
        )}
        <p className="text-xs text-gray-500">This Month</p>
      </View>
    </View>
  );
};

export default MetricCard;
